module.exports = __webpack_public_path__ + "img/secure-system.918007fb.png";